import { FormRow as FormRowCore, IFormRowProps as IFormRowPropsCore } from "@webbio/components";

import styles from "./form-column.module.scss";

const FormColumn = (props: IFormRowPropsCore): JSX.Element => {
  return <FormRowCore {...props} propStyles={styles} />;
};

export { FormColumn };
